import { Navigate } from "react-router-dom";
import { FaReceipt } from "react-icons/fa";
import { MonthlyExpensesViewMain } from "../Components/MonthlyExpensesViewMain";

export const MonthlyExpensesModule = () => [
    {
        views: "PRIVATE", path: "/monthly-expenses/:tab", component: <MonthlyExpensesViewMain />,
        roles: null, permissions: null, label: "Gastos mensuales", icon: null,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false,
        isBlockedWhenLogged: false,
    },
    {
        views: "PRIVATE", path: "/monthly-expenses", component: <Navigate to="/monthly-expenses/summary" replace />,
        roles: null, permissions: null, label: "Gastos mensuales", icon: <FaReceipt />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: true,
        isBlockedWhenLogged: false,
    },
];
